<script setup lang="ts">
import {fetchPricing} from "~/calls/subscription";
import type {Pricing} from "~/types/subscription.types";

const props = withDefaults(defineProps<{
  plan: string,
  quantity: number,
  currency: 'EUR' | 'USD',
}>(), {})

const pricing = ref<Pricing | null>(null)

fetchPricing().then((r) => {
  pricing.value = r
})

const computedPrice = computed(() => {
  const q = props.quantity
  if (!pricing.value) {
    return null
  }
  const pricesForCurrency = pricing.value.prices.filter((price) => price.currency === props.currency)
  if (pricesForCurrency.length === 0) {
    return null
  }
  const priceForCurrency = pricesForCurrency[0]
  const pricingTiers = priceForCurrency.prices[props.plan]!!
      .sort((a, b) => (a.upTo || Infinity) - (b.upTo || Infinity))

  let total = 0
  pricingTiers.forEach((tier, currentIndex) => {
    const tierStart = pricingTiers[currentIndex - 1]?.upTo || 0
    const tierEnd = tier.upTo
    if (q > tierStart) {
      if (tierEnd == null) {
        total += tier.pricePerUnit * (q - tierStart)
      } else {
        total += tier.pricePerUnit * Math.min(q - tierStart, tierEnd - tierStart)
      }
    }
  })
  return total / 100
})

const currencyFormatted = computed(() => {
  return props.currency === 'EUR' ? '€' : '$'
})

</script>

<template>
  <div>
    <div v-if="computedPrice" class="d-flex">
      <div>{{ currencyFormatted }}</div>
      <div>
        <FormattedNumber :number="computedPrice" :decimals="0"/>
      </div>
    </div>
    <div v-else>?</div>
  </div>
</template>
